<script setup lang="ts">
const { broker } = useBroker()

const list = computed(() => {
  if (!broker.value?.property_types_sold) return []

  const total = broker.value.property_types_sold.reduce((sum, property) => sum + property.count, 0)

  return broker.value.property_types_sold
    .map(property => ({
      type_woning: property.type_woning,
      count: property.count,
      percent: Math.round((property.count / total) * 100),
    }))
    .sort((a, b) => b.count - a.count) // Sort by count descending
})

const content = {
  title: 'Type woningen verkocht',
  description: 'Verdeling van verkochte woningen per type',
}
</script>

<template>
  <UCard v-if="broker?.property_types_sold?.length">
    <template #header>
      <div class="flex items-center gap-3">
        <UIcon
          name="i-heroicons-home-20-solid"
          class="flex-shrink-0 w-5 h-5 text-gray-500 dark:text-gray-400"
        />
        <div>
          <h3 class="text-base font-semibold text-gray-900 dark:text-white mt-0 mb-1">
            {{ content.title }}
          </h3>
          <p class="text-sm text-gray-500 dark:text-gray-400 mb-0">
            {{ content.description }}
          </p>
        </div>
      </div>
    </template>

    <div class="flex flex-col space-y-4">
      <div
        v-for="property in list"
        :key="property.type_woning"
        class="flex items-center space-x-4"
      >
        <span class="w-48 text-sm font-medium text-gray-600">
          {{ property.type_woning }}
        </span>
        <div class="relative flex-1 h-4 bg-gray-100 rounded">
          <div
            class="absolute top-0 left-0 h-4 bg-blue-500 rounded transition-all duration-500"
            :style="{ width: `${property.percent}%` }"
          />
          <span class="absolute inset-y-0 right-2 flex items-center text-xs font-medium">
            {{ property.count }} ({{ property.percent }}%)
          </span>
        </div>
      </div>
    </div>
  </UCard>
</template>
